import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KbsSiteDocSearchPageComponent } from './component/kbs-site-doc-search-page.component';
import { ConfigModule, CmsConfig, I18nModule, OccEndpoint, provideDefaultConfig, FeaturesConfigModule, UrlModule, OccProductSearchAdapter } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, PageComponentModule, ProductListModule, SortingModule, SpinnerModule, StarRatingModule } from '@spartacus/storefront';
import { KbDocumentGridItemModule } from '../common/components/kb-document-grid/kb-document-grid.module';
import { KbDocumentListItemModule } from '../common/components/kb-document-list/kb-document-list.module';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { KbsSitePaginationModule } from '../common/components/kbs-site-pagination/kbs-site-pagination.module';
import { FacetNavigationModule } from '../common/components/facet-navigation/facet-navigation.module';
import { KbPipesModule } from '../../pipes/kb-pipes.module';




@NgModule({
  declarations: [KbsSiteDocSearchPageComponent],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    ProductListModule,
    KbDocumentGridItemModule,
    KbDocumentListItemModule,
    SortingModule,
    AtMessageModule,
    FeaturesConfigModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    KbsSitePaginationModule,
    FacetNavigationModule,
    KbPipesModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        KBSDocumentLibraryFlexComponent: {
          component: KbsSiteDocSearchPageComponent,
        },
      },
      skipLinks: [],
    }),
  ],
  providers: [
    OccProductSearchAdapter,
    provideDefaultConfig({
      backend: {
        occ: {
          endpoints: {
            getDocumentSearchFormData: '/documentLibrary/kbRaildocument',
          },
        },
      },
    }),
  ],
})
export class KbsSiteDocSearchPageModule { }

declare module '@spartacus/core' {
  interface OccEndpoints {
    getDocumentSearchFormData?: string | OccEndpoint;
  }
}